export const cancelSubscriptionOptions = [
  { value: 'not_enough', label: "I don't use the services enough" },
  { value: 'not_satisfied', label: 'I am not satisfied with the services' },
  { value: 'moving', label: 'I am moving' },
  { value: 'other', label: 'Other' },
  // Add more objects for additional radio buttons
]
